<template>
  <el-form :model="form" ref="formRef" :rules="rules" label-width="80px" :inline="false">
    <el-form-item v-if="isActive" label="旧密码" prop="old_password">
      <el-input v-model="form.old_password" placeholder="请输入" show-password></el-input>
    </el-form-item>
    <el-form-item label="新密码" prop="new_password">
      <el-input v-model="form.new_password" placeholder="请输入" show-password></el-input>
    </el-form-item>
    <el-form-item label="确认密码" prop="confirm_password">
      <el-input v-model="form.confirm_password" placeholder="请输入" show-password></el-input>
    </el-form-item>
  </el-form>
</template>
<script>
export default {
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const confirmPassword = (_, val, cb) => {
      if (!val) {
        cb(new Error('请输入密码'))
      } else if (this.form.new_password !== val) {
        cb(new Error('前后密码不一致，请确认密码!'))
      } else {
        cb()
      }
    }
    const checkVerify = (_, val, cb) => {
      // 同时满足数字、字母以及特殊字符
      /* eslint-disable */
      const regex = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).*$/
      if (!val) {
        cb(new Error('请输入新密码'))
      } else if (!regex.test(val)) {
        cb(new Error('需同时包含数字、字母以及特殊符号(1@#$%^＆*0等非空格符号）'))
      } else {
        cb()
      }
    }
    return {
      form: {
        confirm_password: '',
      },
      rules: {
        old_password: { required: true, message: '请输入旧密码', trigger: 'blur' },
        new_password: { required: true, validator: checkVerify, trigger: 'change' },
        confirm_password: { required: true, validator: confirmPassword, trigger: 'blur' },
      },
    }
  },
  created() {
    if (this.isActive) {
      this.$set(this.form, 'old_password', '')
      this.$set(this.form, 'new_password', '')
    } else {
      this.$set(this.form, 'new_password', '')
    }
  },
}
</script>
<style scoped>
::v-deep .el-input {
  width: 100%;
}
</style>
